<template>
  <div class="page" id="page-cs">

    <div class="section-header">
      <div class="container">
        <h1>보험 자료실</h1>
      </div>
    </div>

    <div class="section-body" id="insurance-resources">
      <div class="container">
        <div class="section-search">
          <input class="searchBox" v-on:keyup.enter="search" v-model="searchText" />
          <img class="searchButton" :src="'../static/search.png'" @click="search">
        </div>
        <div class="section-list">

          <element-tab>
            <element-tab-item @click="clickTab('보험용어')" :on="introductionTab == '보험용어'">보험용어</element-tab-item>
            <element-tab-item @click="clickTab('질병용어')" :on="introductionTab == '질병용어'">질병용어</element-tab-item>
            <element-tab-item @click="clickTab('건강상식')" :on="introductionTab == '건강상식'">건강상식</element-tab-item>
          </element-tab>


          <element-board>
            <element-board-item :key="index" v-for="(items, index) in data" @clickLazy="updateClicks(items)" @click="openItem === index ? openItem = -1 : openItem = index" :on="openItem == index">
              {{ items.post_subject }}
              <span>
                {{ "날짜 " }} {{ moment(items.createdAt).format('YYYY. MM. DD') }}
                &nbsp&nbsp
                {{ "조회수 " + items.post_view_count }}
              </span>
              <img :src="openItem == index ? '../static/expand_less_primary.png' : '../static/expand_more.png'" />

              <div class="item-description" v-if="openItem == index && items.post_content">
                {{ items.post_content }}
              </div>
            </element-board-item>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              size="sm"
               @input =" updatePage(currentPage); "
              align="center">
            </b-pagination>
          </element-board>

        </div>
      </div>
      </div>
    </div>
  </div>
</template>



<script>
import moment from 'moment';
export default {
  data(){
    return {
      introductionTab: '보험용어',
      searchText: '',
      rows: 10,
      perPage: 10,
      moment: moment,
      currentPage: 1,
      openItem: -1,
      data: [
        { "id": "1", "title": "가족 중 한 사람을 운전자 범위에 포함하는 방법은",  "description": "testtesttest", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "2", "title": "운전자 범위 변경 횟수에 제한있나", "description": "testtestttesttesttestt", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "3", "title": "명절 동안만 가족들이 차량 운전시 대처 방법은", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "4", "title": "자동차보험의 운전자 범위 변경 방법은", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "5", "title": "보험 가입 중 특정 항목을 추가할 수 있나", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "6", "title": "24세 특약인데, 26세가 되면 자동차보험 변경은", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "7", "title": "보험 가입 날짜를 변경하는 방법은", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "8", "title": "3~4일 정도만 운전자 범위 변경이 가능한가", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "9", "title": "자동차보험 처음 가입하는 경우는 언제 가입하나", "description": "실비보험을 오래전에 들은 거라 질병 통원비가 10만원 한도 내에서만 나오는거라 많이 약해 보강 좀 하려고 합니다. 제 담당자께서 정태현 설계사님이신데 전화 좀 부탁드릴께요.", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "10", "title": "자동차보험 만기가 다가오는데 재가입은 언제하나", "description": "", "createAt": "2019-04-09", "clicks": "13" },
      ]
    }
  },
  created() {
    this.updatePage(1);
  },
  methods: {
      clickTab(tab){
        this.introductionTab = tab;

        this.updatePage(1);
      },
      search(evt){
        this.updatePage(1);
      },
      updateClicks(item){
        this.$store.dispatch( "post/updateClicks", { _id: item._id} ).then(res => {
          this.updatePage(this.currentPage);
        })
      },
      updatePage(page){
        this.$data.currentPage = page;


        if(this.introductionTab === '보험용어'){
          this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "datas_insure", search_text: this.searchText  } ).then( res => {
            this.data = res.data.data.items;
          });
        }

        if(this.introductionTab === '질병용어'){
          this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "datas_disease", search_text: this.searchText  } ).then( res => {
            this.data = res.data.data.items;
          })
        }

        if(this.introductionTab === '건강상식'){
          this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "datas_common", search_text: this.searchText  } ).then( res => {
            this.data = res.data.data.items;
          })
        }

      }
  }
}
</script>
